<spark-shared-data-table-wrapper
  [title]="title"
  [downloading]="downloading"
  (downloadClicked)="downloadClicked()">
  <ng-container table-definition>
    <div class="row" *appLoad="let data of data$">
      <div class="col">
        <div class="row mb-3">
          <div class="col">
            <ngx-datatable
              [rows]="data.data"
              [columns]="columns"
              [reorderable]="true"
              [swapColumns]="false"
              rowHeight="auto"
              columnMode="force"
              *ngIf="data">
              <ngx-datatable-column name="Email Campaign Name" [width]="400">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row.canvasName }}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Sent" [width]="80">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row.sendCount | number }}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Delivered" [width]="80">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row.deliveredCount | number }}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Opened" [width]="80">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row.openCount | number }}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Clicked" [width]="80">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row.clickCount | number }}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Unsubscribed" [width]="100">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row.unsubscribeCount | number }}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Bounced" [width]="80">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row.bounceCount | number }}
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
          </div>
        </div>
        <div class="row">
          <div class="col d-flex justify-content-end">
            <spark-shared-pagination
              [currentPage]="data.pagination.currentPage"
              [size]="data.pagination.pageSize"
              [count]="data.pagination.totalItems"
              (gotoPage)="
                pageChanged($event, data.pagination.pageSize)
              "></spark-shared-pagination>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</spark-shared-data-table-wrapper> 